import 'css-chunksrc/client/pages/workloadPage/toolbar/yearNavigation/styles.scss';export default {
  "root": "_root_1fmj9_1",
  "yearNavigation": "_yearNavigation_1fmj9_5",
  "arrow": "_arrow_1fmj9_16",
  "leftArrow": "_leftArrow_1fmj9_23",
  "rightArrow": "_rightArrow_1fmj9_30",
  "year": "_year_1fmj9_5",
  "calendarButton": "_calendarButton_1fmj9_45",
  "opened": "_opened_1fmj9_54",
  "calendarIcon": "_calendarIcon_1fmj9_54",
  "listRoot": "_listRoot_1fmj9_64"
};